import { useSyncExternalStore } from 'react';

type Listener = () => void;

let dynamicTitle = '';
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener());
}

/** 设置动态面包屑末级标题（如订单详情的「采购单 xxx」） */
export function setDynamicBreadcrumbTitle(title: string) {
  if (dynamicTitle === title) return;
  dynamicTitle = title;
  emit();
}

export function clearDynamicBreadcrumbTitle() {
  if (!dynamicTitle) return;
  dynamicTitle = '';
  emit();
}

export function useDynamicBreadcrumbTitle() {
  return useSyncExternalStore(
    (onStoreChange) => {
      listeners.add(onStoreChange);
      return () => {
        listeners.delete(onStoreChange);
      };
    },
    () => dynamicTitle,
    () => '',
  );
}
